import { DocFlowMappingContext } from '../DocFlowMapping'

function DocFlowMappingProvider({ children, ...restProps }) {
  return (
    <DocFlowMappingContext value={restProps}>{children}</DocFlowMappingContext>
  )
}

export default DocFlowMappingProvider
